/* eslint-disable no-undef */

import React, {PureComponent} from 'react'
import {withStyles} from "@material-ui/core/styles/index";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import { Grid, Button } from '@material-ui/core';

const styles = theme => ({
    root: {
        marginTop: theme.spacing(2),
        margin: '0 ' + -theme.spacing(1) * 2 + 'px',
        width: 'calc(100% + ' + theme.spacing(4) + 'px)',
        [theme.breakpoints.up(600)]: {
            marginTop: theme.spacing(6),
            margin: '0 ' + -theme.spacing(1) * 4 + 'px',
            width: 'calc(100% + ' + theme.spacing(8) + 'px)',
        },
    },
    container: {
        padding: '0 ' + theme.spacing(2) + 'px',
        [theme.breakpoints.up(600)]: {
            padding: '0 ' + theme.spacing(4) + 'px',
        },
        paddingBottom: theme.spacing(0.5),
    },
    buttons: {
        display: 'block',
        //justifyContent: 'flex-end',
        /*[theme.breakpoints.down(600)]: {
            position: 'absolute',
            left: 0,
            bottom: 0,
        },*/
    },
    backButton: {
        display: 'block',
        margin: 'auto',
        marginLeft: 0,
        padding: '12px 4px 10px 2px',
        color: theme.backButton ? theme.backButton.color : 'rgba(0, 0, 0, 0.5)',
        width: theme.backButton ? theme.backButton.width : null,
        marginTop: 0,
        marginBottom: 0,
        maxWidth: theme.backButton ? theme.backButton.maxWidth : null,
        [theme.breakpoints.up(600)]: {
            padding: '12px 10px 10px 6px',
            marginTop: theme.backButton ? theme.backButton.marginTop : 7,
            marginBottom: theme.backButton ? theme.backButton.marginBottom : 30,
        },
        borderRadius: theme.borderRadius? theme.backButton.borderRadius: 10,
    },
    twoButtonsBackButton: {
        //marginLeft: theme.spacing.unit * 2,
        [theme.breakpoints.up(600)]: {
            //marginLeft: theme.spacing.unit * 4,
        },
    },
    forwardButton: {
        display: 'block',
        margin: 'auto',
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0,
        padding: '8px 20px',
        [theme.breakpoints.up(600)]: {
            padding: '8px 28px',
            marginTop: theme.forwardButton ? theme.forwardButton.marginTop : 0,
            marginBottom: theme.forwardButton ? theme.forwardButton.marginBottom : theme.spacing(2),
        },
        boxShadow: theme.forwardButton ? theme.forwardButton.boxShadow : null,
        color: theme.forwardButton ? theme.forwardButton.color : null,
        borderRadius: theme.forwardButton ? theme.forwardButton.borderRadius : null,
        width: theme.forwardButton ? theme.forwardButton.width : null,
        maxWidth: theme.forwardButton ? theme.forwardButton.maxWidth : null,
        background: theme.forwardButton ? theme.forwardButton.background : null,
    },
    rightIcon: {
        marginLeft: theme.spacing(1),
        marginRight: -theme.spacing(1) * 0.5,
        minWidth: 20,
        [theme.breakpoints.down(285)]: {
            display: 'none',
        },
    },
    progressBarWrapper: {
        margin: theme.spacing(1.5) + 'px 0',
        background: '#e7e7e7',
    },
    progressBar: {
        background: theme.palette.secondaryColor + '!important',
        height: 10,
    },
});

class QuestionPageNavigation extends PureComponent {

    render() {
        const {classes, questionPage, isLoading, activeStep, next, prev} = this.props;
        return (
            <div className={classes.root}>
                {questionPage && questionPage.stepper && <div className={classes.progressBarWrapper}>
                    <div className={classes.progressBar}
                         style={{width: questionPage.stepper.step / questionPage.stepper.max * 100 + '%'}}>
                    </div>
                </div>}
                <Grid container className={classes.container}>
                    <Grid item xs={5} sm={6} className={classes.buttons} key={'button1'}>
                        {questionPage && questionPage.showBackButton === true && questionPage.stepper && questionPage.stepper.firstStep !== true &&
                        <Button size="small" onClick={prev} disabled={activeStep === 0}
                                className={classes.backButton + ' ' + (questionPage.submitButton.show && questionPage.submitButton.position === 'below' ? classes.twoButtonsBackButton : null)}>
                            <FontAwesomeIcon className={classes.rightIcon} size="lg" style={{marginRight: 4}}
                                             icon={['far', 'long-arrow-alt-left']}/> Takaisin
                        </Button>
                        }
                    </Grid>
                    <Grid item xs={7} sm={6} key={'button2'}>
                        {questionPage.submitButton.show && questionPage.submitButton.position === 'below' &&
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            className={classes.forwardButton+' forwardButton'}
                            onClick={next}
                            disabled={isLoading}
                        >
                            {questionPage.submitButton.label}
                            {!isLoading && <FontAwesomeIcon className={classes.rightIcon} size="lg"
                                                            icon={['far', questionPage.submitButton.icon]}/>}
                            {isLoading && <FontAwesomeIcon className={classes.rightIcon} size="lg"
                                                           icon={['far', 'spinner-third']} spin/>}
                        </Button>}
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default withStyles(styles)(QuestionPageNavigation);
